import { render, staticRenderFns } from "./RcvPD_Total.vue?vue&type=template&id=652cd674"
import script from "./RcvPD_Total.vue?vue&type=script&lang=js"
export * from "./RcvPD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports